const getLightAmountValue = (consumption: number, min: number, max: number) =>
  0.2 + (consumption - min) / (max - min);

export default getLightAmountValue;
